/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ICheckboxStyles } from "office-ui-fabric-react/lib/Checkbox";

import { BREAKPOINTS } from "Constants/Layout";

import { desktopInputFontSize, mobileInputFontSize } from "../ReactHookFormShared.styles";

/**
 * Styling for Checkbox.
 * @type {Partial<ICheckboxStyles>}
 */
export const checkboxStyles: Partial<ICheckboxStyles> = {
  label: {
    width: "100%",
  },
  text: {
    fontSize: desktopInputFontSize,
    selectors: {
      [`@media (max-width: ${BREAKPOINTS.medium}px)`]: {
        fontSize: mobileInputFontSize,
      },
    },
  },
};
